
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4RP7y", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5943acf2971be4ae$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $5943acf2971be4ae$export$2e2bcd8739ae039 = {
    'people.menu.renotify.flag.description': 'We sturen iedereen een e-mail met een herinnering. Dit kan wel een minuut duren.',
    'people.menu.renotify.flag.description.confluence': 'Herinnering sturen naar teamgenoten',
    'people.menu.renotify.flag.title': 'Herinneringen sturen',
    'people.menu.renotify.flag.title.confluence': 'Uitnodiging wordt opnieuw verzonden',
    'people.menu.renotify.menu.description': '{userCount, plural, one {{userCount,number} persoon heeft de uitnodiging voor {product} nog niet geaccepteerd. Bekijk wie er ontbreekt en stuur diegene een herinnering.} other {{userCount,number} personen hebben hun uitnodiging voor {product} nog niet geaccepteerd. Bekijk wie er ontbreken en stuur ze een herinnering.}}',
    'people.menu.renotify.menu.description.confluence': 'Sommige mensen hebben de uitnodiging voor Confluence nog niet geaccepteerd. Bekijk wie er ontbreken en stuur hun een herinnering.',
    'people.menu.renotify.menu.dismiss': 'Negeren',
    'people.menu.renotify.menu.dismiss.confluence': 'Niet nu',
    'people.menu.renotify.menu.remind': 'Teamleden herinneren',
    'people.menu.renotify.menu.remind.confluence': 'Herinnering sturen naar teamgenoten',
    'people.menu.renotify.menu.title': 'Is iedereen er?',
    'people.menu.renotify.modal.copied': 'Link gekopieerd',
    'people.menu.renotify.modal.copy': "Uitnodigingslink kopi\xebren",
    'people.menu.renotify.modal.description': 'We kunnen een herinnering sturen naar de ontbrekende leden, of je kunt de uitnodigingslink zelf delen.',
    'people.menu.renotify.modal.description.confluence': 'Verstuur de uitnodigingsmail opnieuw of kopieer en deel de uitnodigingslink.',
    'people.menu.renotify.modal.dismiss': 'Annuleren',
    'people.menu.renotify.modal.resend': 'Herinnering sturen',
    'people.menu.renotify.modal.resend.confluence': 'Uitnodiging opnieuw versturen',
    'people.menu.renotify.modal.title': 'Ontbrekende leden herinneren',
    'people.menu.renotify.modal.title.confluence': 'Ontbrekende teamgenoten herinneren',
    'ptc.pm.collaborators.title': 'Je teamgenoten',
    'ptc.pm.error-heading': 'Er is iets misgegaan.',
    'ptc.pm.error-image-alt-text': 'Een defecte robot en een aantal mensen die bezig zijn hem te repareren.',
    'ptc.pm.error-text': 'We houden deze fouten bij, maar aarzel niet om contact met ons op te nemen als pagina vernieuwen het probleem niet oplost.',
    'ptc.pm.num-members': '{memberCount, plural, one {{memberCount,number} lid} other {{memberCount,number} leden}}',
    'ptc.pm.people': 'Mensen',
    'ptc.pm.teams': 'Teams',
    'ptc.pm.view-your-profile': 'Je profiel bekijken',
    'ptc.pm.your-teams.title': 'Jouw teams'
};

});


//# sourceMappingURL=nl.8a03b254.js.map
